import DesignLibrary, { DesignLibraryProps } from './DesignLibrary';

import withPresenter from './DesignLibrary.presenter';
import withInteractor from './DesignLibrary.interactor';

const DesignLibraryPage = withInteractor(withPresenter(DesignLibrary));

export type { DesignLibraryProps };
export default DesignLibraryPage;
